import { render, staticRenderFns } from "./myWaterBind.vue?vue&type=template&id=cb04b1cc&scoped=true"
import script from "./myWaterBind.vue?vue&type=script&lang=js"
export * from "./myWaterBind.vue?vue&type=script&lang=js"
import style0 from "./myWaterBind.vue?vue&type=style&index=0&id=cb04b1cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb04b1cc",
  null
  
)

export default component.exports